exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.item-icon[data-v-191ff6dc] {\n    width: 3.125rem;\n    height: 3.125rem;\n}\n.item-icon img[data-v-191ff6dc] {\n    max-width: 80%;\n    max-height: 80%;\n}\n", ""]);

// exports
